import PropTypes from "prop-types"
import Modal from "components/Modal"

const TooltipModal = ({
  isOpen = false,
  handleToggable,
  title = "",
  description = "",
  img,
  children
}) => {
  return (
    <Modal isOpen={isOpen} handleToggable={handleToggable} size="lg">
      <div className="text-center">
        <span style={{ fontSize: "30px" }}>{title && <h2>{title}</h2>}</span>
        <span style={{ fontSize: "24px" }}>{description && <p>{description}</p>}</span>
        <span style={{ fontSize: "18px" }}>{!children ? <img className="img-fluid" src={img} alt="tooltip" /> : children}</span>
      </div>
    </Modal>
  )
}

TooltipModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleToggable: PropTypes.func.isRequired,
  img: PropTypes.string.isRequired,
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

export default TooltipModal
